<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  accepted: { type: Boolean, default: true },
  downloading: { type: Boolean, default: false },
  lastDownload: { type: String, default: '' },
});
const emit = defineEmits(['download', 'update:accepted']);
const { t } = useI18n();

const formattedDownload = computed(() => {
  if (!props.lastDownload) return '';
  const date = new Date(props.lastDownload);
  return Number.isNaN(date.getTime())
    ? props.lastDownload
    : t('SALES.RECEIPT_DRAFT.LATEST_DOWNLOAD', {
        date: date.toLocaleDateString('pt-BR'),
        time: date.toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
        }),
      });
});
</script>

<template>
  <footer
    class="fixed inset-x-0 bottom-0 z-40 border border-lais-border-soft bg-white shadow-sm"
    data-test="sales-receipt-draft-footer"
  >
    <div
      class="mx-auto flex w-full max-w-[1280px] flex-wrap items-center justify-center gap-4 px-5 py-3 sm:justify-between sm:px-10 sm:py-5"
    >
      <label
        class="flex max-w-[365px] items-start gap-2 text-sm text-lais-text"
      >
        <input
          :checked="accepted"
          type="checkbox"
          class="mt-1 size-4 accent-lais-primary"
          data-test="sales-receipt-draft-review-check"
          @change="emit('update:accepted', $event.target.checked)"
        />
        <span>{{ t('SALES.RECEIPT_DRAFT.REVIEW_CHECK') }}</span>
      </label>

      <p v-if="formattedDownload" class="text-sm text-lais-text-muted">
        {{ formattedDownload }}
      </p>

      <LaisPrimaryButton
        :disabled="!accepted || downloading"
        :label="
          downloading
            ? t('SALES.RECEIPT_DRAFT.DOWNLOADING')
            : t('SALES.RECEIPT_DRAFT.DOWNLOAD')
        "
        data-test="sales-receipt-draft-download"
        @click="emit('download')"
      />
    </div>
  </footer>
</template>
